import {Pipe, PipeTransform} from '@angular/core';
import {GenRoleDefinition} from '../../generated/serverModels/GenRoleDefinition';

@Pipe({
  name: 'roleName',
  standalone: true,
})
export class RoleNamePipe implements PipeTransform {

  transform(value: GenRoleDefinition): string {

    switch (value) {
      case GenRoleDefinition.ROLE_ADMIN:
        return 'Application Admin';
      case GenRoleDefinition.ROLE_GDO:
        return 'Grid Deployment Office';
      case GenRoleDefinition.ROLE_APPLICATION_MANAGER:
        return 'Application Manager';
      default:
        return value.name
          .substring(5)
          .toLowerCase()
          .replace(/_/g, ' ')
          .replace(/\b[a-z]/g, (firstLetter) => firstLetter.toUpperCase());
    }

  }

}
